import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { getOnboardingGuideCxToken } from "./onboardingService";

const PageContainer = styled.div``;

export const OnboardingComponent = () => {
  const [iframeUrl, setIframeUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [embedToken, setEmbedToken] = useState("");
  const [projectId, setProjectId] = useState("");
  const [email, setEmail] = useState("");
  const guideCxCustomerUrl = "https://app.guidecx.com/auth/customer-login/sso";

  const getEmbedToken = async () => {
    setLoading(true);

    const data = await getOnboardingGuideCxToken();

    setEmail(data.email);
    setProjectId(data.projectId);
    setEmbedToken(data.embedToken);
    setLoading(false);
  };

  const generateIframeUrl = () => {
    const url = new URL(guideCxCustomerUrl);

    url.searchParams.append("token", embedToken);
    url.searchParams.append("projectId", projectId);
    url.searchParams.append("email", email);

    return url.toString();
  };

  useEffect(() => {
    const url = generateIframeUrl();

    setIframeUrl(url);
  }, [embedToken]);

  useEffect(() => {
    getEmbedToken();
  }, []);

  return (
    <PageContainer>
      {iframeUrl && !loading ? (
        <iframe style={{ width: "100%", height: "80vh" }} src={iframeUrl}/>
      ) : null}
    </PageContainer>
  );
};

export default OnboardingComponent;
